import { BOARD_PACK_REPORT } from './boardPack.js'
import { CLOSED_WON_REPORT } from './closedWon.js'
import { COMPETITOR_DIGEST_REPORT } from './competitorDigest.js'
import { DEMO_REQUEST_REPORT } from './demoRequest.js'
import { GITHUB_BUG_REPORT } from './githubBug.js'
import { INBOX_BRIEF_REPORT } from './inboxBrief.js'
import { MEETING_BRIEF_REPORT } from './meetingBrief.js'
import { PIPELINE_REPORT } from './pipeline.js'
import { RELEASE_NOTES_REPORT } from './releaseNotes.js'
import { SPEC_EDIT_REPORT } from './specEdit.js'
import { SUPPORT_PULSE_REPORT } from './supportPulse.js'
import { TRADEMARK_WATCH_REPORT } from './trademarkWatch.js'

/** What each sample schedule or trigger produces when it runs, keyed by source id. */
export const DEMO_REPORTS = {
  'demo-sch-inbox-brief': INBOX_BRIEF_REPORT,
  'demo-sch-pipeline': PIPELINE_REPORT,
  'demo-sch-trademark-watch': TRADEMARK_WATCH_REPORT,
  'demo-sch-competitor-digest': COMPETITOR_DIGEST_REPORT,
  'demo-sch-support-pulse': SUPPORT_PULSE_REPORT,
  'demo-sch-board-pack': BOARD_PACK_REPORT,
  'demo-sch-release-notes': RELEASE_NOTES_REPORT,
  'demo-trg-demo-request': DEMO_REQUEST_REPORT,
  'demo-trg-closed-won': CLOSED_WON_REPORT,
  'demo-trg-github-bug': GITHUB_BUG_REPORT,
  'demo-trg-meeting-brief': MEETING_BRIEF_REPORT,
  'demo-trg-spec-edit': SPEC_EDIT_REPORT,
}
